

































































import moment from 'moment'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import AListCustom from '../../../../../../../../components/AListCustom/AListCustom.vue'
import AListCustomItem from '../../../../../../../../components/AListCustom/AListCustomItem.vue'
import { BonusInfoInvoice, ReferralInvoiceDirection } from '../../../../../../includes/types/BonusHistory'
import ReceiveCashIcon from '../icons/ReceiveCashIcon.vue'
import WrightOff from '../icons/WrightOffIcon.vue'

@Component({
  components: {
    AListCustom,
    AListCustomItem,
    WrightOff,
    ReceiveCashIcon,
  },
})
export default class InvoiceCard extends Vue {
  @Prop() readonly invoice!: BonusInfoInvoice

  private get reward(): string | null {
    if (this.invoice.bonus && this.invoice.bonus.length > 0) {
      return `${ this.invoice.bonus.map((bonus) => bonus.reward).reduce((prev: number, curr: number) => prev + curr, 0) }${ this.invoice.bonus[0].currency.symbol }`
    }
    return null
  }

  private get isBoughtWithReward(): boolean {
    return this.invoice.ref !== undefined && this.invoice.ref.length > 0
  }

  private get wrightOffAmount(): string | null {
    if (this.isBoughtWithReward) {
      return `${ this.invoice.ref!
        .map((ref) => (ref.direction === ReferralInvoiceDirection.FillOut ? ref.reward : 0))
        .reduce((a: number, b: number) => a + b, 0) }${ this.invoice.currency.symbol }`
    }
    return null
  }

  get formattedDate() {
    return moment(this.invoice.invoice_date_time).format('LLL')
  }
}
